import { useEffect, useState } from 'react';

import { logEvent } from '@firebase/analytics';
import { vodList as aodAPI } from '@/network/apis/apiUri';
import analytics from '../../../../firebase';
import { MainHead, Pagination } from '../common';

export default function ProgramPodcast(props) {
  const { mode, history, selBoard, search, isRadioPlay, setIsRadioPlay } = props;

  const [podList, setPodList] = useState();
  const [listPageInfo, setListPageInfo] = useState();

  const [textOpen, setTextOpen] = useState(null);

  const textOpenBtn = (e) => {
    textOpen === e ? setTextOpen(null) : setTextOpen(e);
  };

  const handlePageBtn = (e) => {
    const { value } = e.currentTarget;

    const searchParams = new URLSearchParams(search);
    const nowPage = searchParams.get('page') ?? 1;

    if (value === 'nextPage') {
      searchParams.set('page', +nowPage + 1);
    }
    if (value === 'prevPage') {
      searchParams.set('page', +nowPage - 1);
    }
    if (value === 'firstPage') {
      searchParams.set('page', 1);
    }
    if (value === 'lastPage') {
      searchParams.set('page', listPageInfo.total_page_count);
    }
    if (!isNaN(Number(value))) {
      searchParams.set('page', value);
    }

    history.push(`?${searchParams.toString()}`);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const searchParams = new URLSearchParams(search);

    const formData = new FormData(e.currentTarget);

    const searchOpt = formData.get('searchOpt');
    const searchText = formData.get('searchText') ?? '';

    if (searchOpt) searchParams.set('searchOpt', searchOpt);
    if (searchText) searchParams.set('searchText', searchText);
    else searchParams.delete('searchText');
    searchParams.delete('page');

    history.push(`?${searchParams.toString()}`);
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(search);
    const page = searchParams.get('page') ?? 1;
    const searchOpt = searchParams.get('searchOpt') ?? null;
    const searchText = searchParams.get('searchText') ?? null;

    aodAPI({
      lan_code: mode,
      board_id: selBoard.boardId,
      program_type: 'radio',
      type: 'aod',
      reg_order: 'desc',
      page_info: { row_count: 10, number: page - 1 },
      key_word: searchText ? searchOpt : null,
      word: searchText,
    })
      .then((res) => {
        if (res.status === 200) {
          const pageInfo = res.data.paging_info;
          const data = res.data.item
            .filter((el) => el.is_open_allow)
            .map((el, i) => ({
              key: `podcast_${el.vod_id}`,
              no: pageInfo.total_item_count - (pageInfo.number * 10 + i),
              vodId: el.vod_id,
              cornerId: el.corner_id,
              broadDate: el.broadcast_date ? el.broadcast_date.slice(0, 10) : '',
              title: el.title,
              content: el.content.replace(/(?:\r\n|\r|\n)/g, '<br />'),
              media: {
                key: el.media_info.media_content_key,
              },
              image: el.image_url,
            }));
          setListPageInfo(pageInfo);
          if (data.length) setPodList(data);
          else setPodList(undefined);
        }
      })
      .catch(() => setPodList(undefined));

    return () => {
      setListPageInfo((prev) => prev);
      setPodList((prev) => prev);
    };
  }, [search]);

  return (
    <div id="CommonProgramBoard" className="commonProgramBoard">
      <MainHead title={selBoard.title} mode={mode} handleSubmit={handleSubmit} />
      <div className="commonProgramBoard_content">
        {!podList && (
          <table className="table">
            <caption className="sr-only">{'Podcast'}</caption>
            <colgroup>
              <col width="12%" />
              <col width="*" />
              <col width="*" />
            </colgroup>
            <thead className="table_head">
              <tr className="table_row">
                <th className="table_row_head" scope="col">
                  NO
                </th>
                <th className="table_row_head" scope="col" style={{ textAlign: 'left', padding: ' 0 28px' }}>
                  Date(KST)
                </th>
                <th className="table_row_head" scope="col">
                  Title
                </th>
              </tr>
            </thead>
            <tbody className="table_body">
              <tr className="table_row alert">
                <td className="table_row_data style_center" colSpan={4}>
                  <div className="alert">
                    <img
                      className="alert_img"
                      src={require('@/assets/images/icon/ico_alert.png').default}
                      alt="There is no item yet"
                    />
                    <p className="alert_text">There is no PodCast yet</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        )}
        {podList && (
          <table className="table">
            <caption className="sr-only">Podcast List Table</caption>
            <colgroup>
              <col width="12%" />
              <col width="14%" />
              <col width="72%" />
            </colgroup>
            <thead className="table_head">
              <tr className="table_row">
                <th className="table_row_head" scope="col">
                  NO
                </th>
                <th className="table_row_head" scope="col" style={{ textAlign: 'left', padding: ' 0 28px' }}>
                  Date(KST)
                </th>
                <th className="table_row_head" scope="col">
                  Title
                </th>
              </tr>
            </thead>
            <tbody className="table_body">
              {podList.map((v, i) => (
                <tr className="table_row" key={v.key}>
                  <td className="table_row_data style_center" style={{ verticalAlign: 'top' }}>
                    <p className="pod-num">{v.no}</p>
                  </td>
                  <td className="table_row_data pod" style={{ verticalAlign: 'top' }}>
                    <p className="pod_time time-fs-fixed">{v.broadDate}</p>
                    <button
                      type="button"
                      className={`pod_btn ${isRadioPlay.aod[0] === v.vodId ? 'on' : 'off'}`}
                      onClick={() => {
                        if (isRadioPlay.aod[0] === v.vodId) {
                          isRadioPlay.aodController[0].pause();
                          setIsRadioPlay((prev) => ({
                            ...prev,
                            footerPlayed: false,
                            aod: [-1, v.title, v.image, v.broadDate, v.cornerId],
                          }));
                        } else {
                          setIsRadioPlay((prev) => ({
                            ...prev,
                            footerPlayed: true,
                            radioPlayed: false,
                            contentKey: [v.media.key, i, v.vodId],
                            aod: [v.vodId, v.title, v.image, v.broadDate, v.cornerId],
                            aodData: podList,
                          }));
                          isRadioPlay.aodController[0]?.play();
                        }
                        logEvent(analytics, 'select_item', {
                          item_list_name: `${v.title}`,
                          item_list_id: `aod_${v.vodId}`,
                          items: [
                            {
                              item_id: `${v.vodId}`,
                              item_name: `${v.title}`,
                              item_brand: 'aod',
                            },
                          ],
                        });
                      }}
                    >
                      <p className="sr-only">Podcast {isRadioPlay.aod[0] === v.vodId ? 'Pause' : 'Play'}</p>
                    </button>
                  </td>
                  <td className="table_row_data">
                    <button type="button" className="data" onClick={() => textOpenBtn(v.no)}>
                      <h3 className="data_title">{v.title}</h3>
                      <p
                        className={`data_info ${textOpen === v.no ? 'on' : 'off'}`}
                        dangerouslySetInnerHTML={{ __html: v.content }}
                      ></p>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {listPageInfo && (
        <Pagination
          nowPage={listPageInfo.number}
          totalPage={listPageInfo.total_page_count}
          handlePageBtn={handlePageBtn}
        />
      )}
    </div>
  );
}
